import styled from 'styled-components'

export const StyledDiv = styled.div`
  height: auto; // Reset height
  width: auto; // Reset width
`
